import { render } from "./QuestionSectionShowComponent.vue?vue&type=template&id=f9cb03dc"
import script from "./QuestionSectionShowComponent.vue?vue&type=script&lang=js"
export * from "./QuestionSectionShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__